module.exports = __webpack_public_path__ + "static/img/noticia12.b6bfa9b4.jpg";